export const stepOneData = [
  {
    heading: "Understanding Your EMI: How SBI Car Loan Works ",
    // paras before heading
    paraOne: "Your Equated Monthly Installment (EMI) is made up of:",

    infoList: [
      {
        heading: "Principal Amount: ",
        description: "The loan amount borrowed for your car purchase.",
      },
      {
        heading: "Interest Component: ",
        description: "The cost paid to SBI for lending you the money.",
      },
    ],
    paraTwo: "Why Calculate Your EMI Before Taking an SBI Car Loan?",

    infoListTwo: [
      {
        description:
          "Compare EMI options and loan offers from SBI and other lenders.",
      },
      {
        description: "Avoid surprises in repayment costs or hidden charges.",
      },
      {
        description:
          "Select the best tenure to match your budget and financial goals.",
      },
    ],
  },
];

export const stepTwoData = [
  {
    heading: "SBI Car Loan EMI & Total Repayment ",

    tableContent: {
      heading: [
        {
          head: "Loan Amount",
        },
        {
          head: "Interest Rate",
        },
        {
          head: "Tenure",
        },
        {
          head: "EMI",
        },
        {
          head: "Total Interest Payable",
        },
      ],
      row: [
        {
          amount: "₹8,00,000",
          interest: "8.65% p.a.",
          tenure: "5 Years",
          emi: "₹16,490",
          payable: "₹1,89,400",
        },
        {
          amount: "₹8,00,000",
          interest: "8.65% p.a.",
          tenure: "7 Years",
          emi: "₹12,990",
          payable: "₹2,44,680",
        },
      ],
    },
    tip: "A longer tenure lowers the EMI but increases the total interest paid. Choose wisely!",
  },
];

export const stepFourData = [
  {
    heading: "What Affects Your SBI Car Loan EMI? ",

    list: [
      {
        head: "Loan Amount:  ",
        info: "Higher loan amounts lead to larger EMIs.",
      },
      {
        head: "Interest Rate:  ",
        info: "Even a slight difference in rates significantly impacts total repayment.",
      },
      {
        head: "Loan Tenure: ",
        info: "Shorter tenures result in higher EMIs but lower interest costs.",
      },
      {
        head: "Processing Fees:  ",
        info: "A 750+ score increases chances of securing a lower interest rate.",
      },
      {
        head: "Processing Fees & Hidden Charges: ",
        info: "Always compare the Annual Percentage Rate (APR) instead of just the interest rate.",
      },
    ],
  },
];

export const stepThreeData = [
  {
    heading: "Why Compare APR Instead of Just Interest Rates?  ",

    paraOne:
      "APR includes all fees (processing charges, administrative costs, etc.), giving a clearer picture of loan affordability.",

    paraTwo:
      "A loan with 8.75% interest and low processing fees may be cheaper than a loan at 8.65% with higher fees.",
    tip: "Always check and compare APRs across lenders before finalizing your loan!",
  },
];

// =====================

export const stepFiveData = [
  {
    heading: "How Your Credit Score Affects SBI Car Loan Offers ",
    subtitle:
      "A strong credit score = lower interest rates & better loan terms!",

    tableContent: {
      heading: [
        {
          head: "Credit Score",
        },
        {
          head: "Expected Interest Rate ",
        },
        {
          head: "Loan Approval Chances",
        },
      ],
      row: [
        {
          credit: "750+",
          interest: "8.50% – 8.65%	",
          chance: "High",
        },
        {
          credit: "650-749",
          interest: "8.75% – 9.50%",
          chance: "Moderate",
        },
        {
          credit: "Below 650",
          interest: "10%+	",
          chance: "Low (may require a co-applicant)",
        },
      ],
    },
    tip: "If your credit score is low, repay existing debts and avoid multiple loan applications to improve approval chances!",
  },
];

export const stepSixData = [
  {
    heading: "How to Use the SBI Car Loan EMI Calculator? ",

    creditScoreList: [
      {
        info: "Enter your loan amount, interest rate, and tenure.",
      },
      {
        info: "Click Calculate to get an instant EMI breakdown.",
      },
      {
        info: "Adjust values to compare different loan scenarios.",
      },
      {
        info: "Plan your budget accordingly before applying for the loan.",
      },
    ],
  },
];
export const stepSevenData = [
  {
    heading: "SBI Car Loan Benefits ",
    tip: "SBI often offers lower rates for Electric Vehicles (EVs). Check for seasonal discounts!",
  },
];

export const stepEightData = [
  {
    heading: "How to Reduce Your SBI Car Loan EMI?",
    tip: "If you expect a salary hike, choose a prepayment-friendly loan to repay faster and reduce interest costs!",
  },
];

export const stepNineData = [
  {
    heading: "Plan Your Finances with SBI Today!",
    paraOne:
      "Use the SBI Loan EMI Calculator to make smarter financial decisions. Explore your loan options and get started on your financial journey with State Bank of India.",
  },
];
